module.exports = __webpack_public_path__ + "fonts/Rubik-300-latin12.b65daad.woff2";